import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c80d3ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "icon icon-button" }
const _hoisted_3 = ["src"]

import ScrollableElement from "@/lib/components/flexible/ScrollableElement.vue";
  import {computed} from "vue";
  import {PopUpsStoreManager} from "@/lib/store/manager/popup/PopUpsStoreManager";

  
export default /*#__PURE__*/_defineComponent({
  name: 'PopUp',
  props: {
    title: {
      type: String,
      required: true,
    },
    popupClass: {
      type: String,
      required: true,
    },
    isVisibleByDefault: {
      type: Boolean,
      default: false,
    },
    defaultInstanceId: String
  },
  setup(__props) {

const props = __props

  

  const instanceId = PopUpsStoreManager.registerPopUp(props.isVisibleByDefault, props.defaultInstanceId);

  const isVisible = computed(() => {
    return PopUpsStoreManager.store.popUpOfInstanceId(instanceId)?.isVisible;
  })
  
  const closePopUp = () => {
    PopUpsStoreManager.store.setPopUpStateVisibility({
      visibility: false,
      instanceId: instanceId
    });
  }


return (_ctx: any,_cache: any) => {
  return (_unref(isVisible))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "outline",
        onClick: _withModifiers(closePopUp, ["self"])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass('popup ' + __props.popupClass)
        }, [
          _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "popup-close",
              src: require('@/lib/assets/img/icons/close.svg'),
              onClick: closePopUp,
              alt: "close popup"
            }, null, 8, _hoisted_3)
          ]),
          _createVNode(ScrollableElement, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ], 2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})